// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".d-none[data-v-65767031]{display:none}.rowinfo[data-v-65767031]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.contentinfo[data-v-65767031]{-webkit-box-flex:1;-ms-flex:1;flex:1}.buttoninfo[data-v-65767031]{margin-left:8px}.btn-download[data-v-65767031]{text-transform:none}", ""]);
// Exports
module.exports = exports;
